/* ============================================================
   Cart drawer enhancements
   - Free-shipping progress bar live-updates on theme:cart:change
   - "You may also like" loads Shopify product recommendations
     (Search & Discovery powered) for the first cart item and injects
     the theme-native product-clip cards. Add-to-cart / quick view is
     handled by the product-clip component itself (theme AJAX), so there
     is no custom add logic here — no duplicate behaviour or listeners.
   No jQuery, no external dependencies, scoped to the drawer.
   ============================================================ */
(function () {
  'use strict';

  var SEL = {
    root:         '[data-cart-drawer-root]',
    progress:     '[data-cd-progress]',
    progressFill: '[data-cd-progress-fill]',
    progressMsg:  '[data-cd-progress-message]',
    recBlock:     '[data-cd-rec][data-cd-rec-dynamic]',
    recRow:       '[data-cd-rec-row]',
    recResults:   '[data-cd-rec-results]',
    recItem:      '.cd-rec__item',
    drawer:       '[data-drawer="drawer-cart"]'
  };

  function cartRoute() {
    return (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
  }
  function recRoute() {
    return (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url) || '/recommendations/products';
  }

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    try {
      if (window.themeCurrency && window.theme && window.theme.moneyFormat) {
        return window.themeCurrency.formatMoney(cents, window.theme.moneyFormat);
      }
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
    } catch (_) {}
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------- Free shipping progress ---------------- */
  function updateProgress(root, totalPriceCents) {
    var progress = root.querySelector(SEL.progress);
    if (!progress) return;

    var thresholdDollars = parseFloat(progress.getAttribute('data-threshold'));
    if (!thresholdDollars || thresholdDollars <= 0) return;

    var thresholdCents = Math.round(thresholdDollars * 100);
    var total = Math.max(Number(totalPriceCents) || 0, 0);
    var remaining = Math.max(thresholdCents - total, 0);
    var pct = Math.min((total / thresholdCents) * 100, 100);

    var fill = progress.querySelector(SEL.progressFill);
    var msg  = progress.querySelector(SEL.progressMsg);

    if (fill) fill.style.width = pct + '%';

    if (total >= thresholdCents) {
      progress.classList.add('cd-progress--unlocked');
      if (msg) msg.innerHTML = progress.getAttribute('data-message-above') || '';
    } else {
      progress.classList.remove('cd-progress--unlocked');
      var tpl = progress.getAttribute('data-message-below') || '';
      var amountHtml = '<strong>' + formatMoney(remaining) + '</strong>';
      if (msg) msg.innerHTML = tpl.replace(/\|\|amount\|\|/g, amountHtml);
    }
  }

  /* ------------- "You may also like" recommendations ------------- */
  var recState = { lastProductId: null, inFlight: false };

  function firstCartProductId(cart) {
    if (cart && cart.items && cart.items.length) {
      return cart.items[0].product_id || null;
    }
    return null;
  }

  function injectRecommendations(root, block, row, productId) {
    var intent = block.getAttribute('data-cd-rec-intent') || 'related';
    var limit  = parseInt(block.getAttribute('data-cd-rec-limit'), 10) || 4;
    // Request a few extra so cart de-duping doesn't under-fill the row.
    var fetchLimit = limit + 4;
    var url = recRoute() +
      '?section_id=api-cart-recommendations' +
      '&product_id=' + encodeURIComponent(productId) +
      '&intent=' + encodeURIComponent(intent) +
      '&limit=' + fetchLimit;

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var results = tmp.querySelector(SEL.recResults);
        var items = results ? results.querySelectorAll(SEL.recItem) : [];
        if (!items.length) return; // nothing dynamic — keep fallback / hidden state
        row.innerHTML = '';
        for (var i = 0; i < items.length && i < limit; i++) {
          row.appendChild(items[i]);
        }
        block.classList.remove('cd-rec--empty');
        // product-clip cards self-initialise (Alpine), like the theme's other
        // dynamically-injected product cards (api-product-upsell-item / related).
      });
  }

  function loadRecommendations(root, cart) {
    var block = root.querySelector(SEL.recBlock);
    if (!block) return;
    var row = block.querySelector(SEL.recRow);
    if (!row) return;

    function run(productId) {
      if (!productId || recState.inFlight) return;
      if (productId === recState.lastProductId) return; // already handled this product
      recState.inFlight = true;
      recState.lastProductId = productId;
      injectRecommendations(root, block, row, productId)
        .catch(function (err) { console.warn('[cart-drawer] recommendations load failed', err); })
        .then(function () { recState.inFlight = false; });
    }

    if (cart) {
      run(firstCartProductId(cart));
    } else {
      fetch(cartRoute() + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { run(firstCartProductId(c)); })
        .catch(function () {});
    }
  }

  // Remove any recommendation whose product is now in the cart (e.g. just added).
  function pruneInCartRecs(root, cart) {
    var block = root.querySelector(SEL.recBlock);
    if (!block || !cart || !cart.items) return;
    var row = block.querySelector(SEL.recRow);
    if (!row) return;

    var inCart = {};
    for (var i = 0; i < cart.items.length; i++) { inCart[cart.items[i].product_id] = true; }

    var items = row.querySelectorAll(SEL.recItem);
    for (var j = 0; j < items.length; j++) {
      var holder = items[j].querySelector('[data-quickview-holder]');
      var pid = holder ? parseInt(holder.getAttribute('data-quickview-holder'), 10) : 0;
      if (pid && inCart[pid] && items[j].parentNode) {
        items[j].parentNode.removeChild(items[j]);
      }
    }

    // If everything was pruned, fetch a fresh set for the current first item.
    if (!row.querySelector(SEL.recItem)) {
      recState.lastProductId = null;
      loadRecommendations(root, cart);
    }
  }

  /* ----------------------------- init ----------------------------- */
  function init(root) {
    if (!root || root.__cdInit) return;
    root.__cdInit = true;

    loadRecommendations(root);

    document.addEventListener('theme:cart:change', function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (!cart) return;
      updateProgress(root, cart.total_price);
      loadRecommendations(root, cart);
      pruneInCartRecs(root, cart);
    });

    var drawerEl = root.querySelector(SEL.drawer);
    if (drawerEl) {
      drawerEl.addEventListener('theme:drawer:open', function () {
        loadRecommendations(root);
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll(SEL.root);
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init if the drawer is injected/re-rendered later (theme section re-render)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector(SEL.root)) {
      boot();
    }
  });
})();
